<script lang="ts" setup>
import { ToccoEventItem } from '~/api/drupal'
import { normalizeDurationDays } from '~/lib/utils/toccoUtils'

const props = defineProps<{
  item: ToccoEventItem
}>()

const { t } = useI18n()

const duration = computed(() => {
  const durationDays = normalizeDurationDays(props.item.durationDays)
  return durationDays ? t('tocco.durationDays', durationDays) : ''
})
</script>

<template>
  <li class="event-row">
    <div class="content">
      <span class="type text-xsmall f-medium">{{ item.type }}</span>
      <NuxtLink :to="item.url" class="title-link">
        <h3 class="title">{{ item.title }}</h3>
      </NuxtLink>
      <span v-if="duration" class="duration text-xsmall">{{ duration }}</span>
    </div>
    <NuxtLink :to="item.url" :title="item.title" class="arrow-link">
      <ButtonIcon />
    </NuxtLink>
  </li>
</template>

<style lang="scss" scoped>
.event-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: var(--gap);

  border-bottom: 1px solid var(--c-line-light);
  @include fluid(padding-block, 24px, 32px);
}

.content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.type {
  color: var(--c-primary);
}

.title {
  margin-bottom: 0;
  color: var(--c-primary);
}

.duration {
  margin-top: 8px;

  color: var(--c-text-dark);
}

.arrow-link {
  display: flex;
}
</style>
